module.exports = __webpack_public_path__ + "static/media/acces-pro.3af0b1a5.svg";